import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Select from 'react-select';
import {
    fetchLiquidacionporid,
    fetchLiquidacionporidOrdenes,
    fetchLiquidacionporidNovedades,
    fetchLiquidacionporidLogistica,
    resetLiquidaciones,
    fetchResultadosLiquidaciones,
    updateLiquidaciones,
    updateEstadoLiquidacion,
    limpiarLiquidacionesBusqueda,
    updateEstadoListLiquidacion,
    fetchDetalleRetenciones,
    resetPercepcionRetencionLiquidacion,
    fetchCalcularPercepcionRetencion,
    actualizarTotalRetencionesOrdenes
} from '../../../../actions/LiquidacionesActions';
import {
    fetchExportarLiquidacionExcelApi,
    postCalcularPercepcionRetencionApi,
    putEditaLiquidacion,
    putEliminaLiquidacionFinal,
    putConfirmarLiquidacion,
    getTipoComprobantesApi,
    fetchExportarRetencionesYPercepcionesApi,
    getDetallesRetenciones,
    fetchExportarCertificadosPdfApi,
    postFacturarLiquidacionApi
} from '../../../../api/axios.js';
import { Modal, Button } from 'react-bootstrap';
import DetalleLiquidacionEditar from './DetalleLiquidacionEditar';
import OrdenesDeLiquidacionBorrador from './OrdenesDeLiquidacionBorrador';
import NovedadesDeLiquidacionBorrador from './NovedadesDeLiquidacionBorrador';
import LogisticaDeLiquidacion from './LogisticaDeLiquidacion';
import RebatesDeLiquidacion from "./RebatesDeLiquidacion";
import GoBackArrow from '../../../General/GoBackArrow';
import { toast } from 'react-toastify';
import MiniSpinner from '../../../General/MiniSpinner';
import { DropDownArrow, customStyle } from '../../../../template/CustomStyle';
import ModalDetallePercepciones from './ModalDetallePercepciones.js';
import ModalDetalleRetenciones from './ModalDetalleRetenciones.js';
import { FileArchive, FileSpreadsheet, FileText, Download, FileDown } from "lucide-react";

// Wrapper para usar hooks en class component
function EditarLiquidacionBorradorWrapper(props) {
    const navigate = useNavigate();
    const { id, idSeller } = useParams();
    const location = useLocation();
    return <EditarLiquidacionBorrador {...props} navigate={navigate} id={id} idSeller={idSeller} location={location} />;
}


class EditarLiquidacionBorrador extends Component {
    constructor(props) {
        super(props);
        this.idOrdenesSeleccionadas = React.createRef();
        this.idNovedadesSeleccionadas = React.createRef();
        this.state = {
            request: {
                idLiquidacion: parseInt(this.props.id),
                idSeller: parseInt(this.props.idSeller),
                borrador: 1
            },
            showSpinner: false,
            spinnerConfirmar: false,
            tipoFactura:
            {
                value: null,
                label: null
            },
            mostrarModalRetenciones: false,
            mostrarModalPercepciones: false,
            detalleOrdenes: [],
            detalleLiquidacion: [],
            showSpinnerCertificados: false,
            mostrarModalDecisionFactura: false
        }
    };

    componentDidMount() {
        this.props.fetchLiquidacionporid(this.state.request);
        //this.setState({tipoFactura.value = this.props.liquidacion_por_id.IdTipoFactura})
    }


    gestionarLiquidacion = async (event, idEstado) => {

        event.preventDefault();

        let idOrdenes = this.idOrdenesSeleccionadas
            .current
            .state
            .ordenes
            .filter(x => x.checked === true)
            .map(x => x.idOrden);

        if (idOrdenes.length === 0) {
            toast.warn("Seleccione alguna orden. No puede crear una liquidacion sin orden");
            return;
        }

        let idNovedades = this.idNovedadesSeleccionadas
            .current
            .state
            .novedades
            .filter(x => x.checked === true)
            .map(x => x.idNovedad);

        let data = {
            CuerpoOrdenes: idOrdenes,
            CuerpoNovedad: idNovedades,
            IdLiquidacion: this.state.request.idLiquidacion,
            IdEstado: idEstado
        }

        let post = putEditaLiquidacion(data);

        post.then(res => {
            toast.success("La liquidacion fue actualizada con exito.");
            this.props.resetLiquidaciones()
            this.props.navigate("/Liquidaciones");
        }).catch(err => {
            toast.error("No pudimos actualizar la liquidacion");
            this.props.navigate("/");
        });
    }

    handleNumeroFacturaChange = (e) => {
        const input = e.target.value || "";
        // Solo dígitos y letras, sin guiones ni otros caracteres
        const limpio = input.replace(/[^0-9a-zA-Z]/g, "").toUpperCase();

        const parte1 = limpio.slice(0, 4);
        const parte2 = limpio.slice(4, 12);
        const parte3 = limpio.slice(12, 13);

        let formateado = parte1;
        if (limpio.length > 4) {
            formateado += "-" + parte2;
        }
        if (limpio.length > 12) {
            formateado += "-" + parte3;
        }

        this.setState({ numeroFactura: formateado });
    };

    confirmarLiquidacion = async (event) => {
        event.preventDefault();

        const { numeroFactura, tipoFactura, request, codigoSAP } = this.state;

        if (!numeroFactura) {
            toast.warn("Debe ingresar un Numero de Factura.");
            return;
        }

        const formatoValido = /^\d{4}-\d{8}-[A-Z]$/;
        if (!formatoValido.test(numeroFactura)) {
            toast.warn("El Número de Factura debe tener el formato 0000-00000000-X (4 dígitos, guion, 8 dígitos, guion y una letra).");
            return;
        }

        if (!tipoFactura) {
            toast.warn("Debe seleccionar un Tipo de Factura.");
            return;
        }

        // En vez de confirmar directo, abrimos modal para decidir el modo
        this.setState({ mostrarModalDecisionFactura: true });
    };

    ejecutarConfirmacionManual = async () => {
        const { numeroFactura, tipoFactura, request, codigoSAP } = this.state;


        let data = {
            IdLiquidacion: request.idLiquidacion,
            NumeroComprobante: numeroFactura,
            IdTipoComprobante: tipoFactura.value,
            codigoSAP: parseInt(codigoSAP)
        };

        this.setState({ spinnerConfirmar: true, mostrarModalDecisionFactura: false });
        try {
            await putConfirmarLiquidacion(data);
            toast.success("La liquidacion fue confirmada con exito.");

            const liquidacionEstadoActualizado = {
                ...this.props.liquidacion_por_id,
                numeroComprobante: numeroFactura,
                idTipoFactura: tipoFactura.value,
                descripcionTipoFactura: tipoFactura.label, // opcional pero útil
                codigoSap: parseInt(codigoSAP),
                idTipoEstadoLiquidacion: 3 // Confirmado
            };

            this.props.updateEstadoLiquidacion(liquidacionEstadoActualizado);

            this.props.updateEstadoListLiquidacion(this.props.liquidaciones, liquidacionEstadoActualizado.idLiquidacion)

        } catch (err) {
            err.response?.data?.errores
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo confirmarse");
        } finally {
            this.setState({ spinnerConfirmar: false });
        }
    };

    ejecutarFacturacionAutomatica = async () => {
        const { request } = this.state;

        this.setState({ spinnerConfirmar: true, mostrarModalDecisionFactura: false });
        try {
            await postFacturarLiquidacionApi({ idLiquidacion: request.idLiquidacion });
            toast.success("Liquidacion facturada automáticamente y confirmada exitosamente.");

            // Refrescar y volver o ir a listado
            this.props.resetLiquidaciones();
            this.props.navigate("/Liquidaciones");
        } catch (err) {
            err.response?.data?.errores
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo completarse la facturación automática.");
        } finally {
            this.setState({ spinnerConfirmar: false });
        }
    };

    editarBorrador = (event) => {
        this.gestionarLiquidacion(event, 2);
    }


    eliminarLiquidacion = (idLiquidacion) => {
        let request = { IdLiquidacion: idLiquidacion };

        putEliminaLiquidacionFinal(request)
            .then(res => {
                this.props.updateLiquidaciones(this.props.liquidaciones, idLiquidacion)
                toast.success("La liquidacion fue eliminada con exito");
                this.props.navigate("/Liquidaciones");
            })
            .catch(err => {
                if (err.response?.data?.errores?.length) {
                    err.response.data.errores.forEach(error => toast.error(error));
                } else {
                    toast.error("No pudo eliminarse");
                }
            });
    };

    descargarExcelBorradorLiquidaciones = async (id, razonSocialSeller) => {
        this.setState({
            showSpinner: true
        });

        let request = {
            idLiquidacion: id,
        };

        try {
            let res = await fetchExportarLiquidacionExcelApi(request);

            let resBase64 = res.excel;

            if (resBase64) {
                const byteCharacters = atob(resBase64);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const razonSocialLimpia = razonSocialSeller.replace(/[^a-zA-Z0-9_]/g, "_");
                const fileName = `${razonSocialLimpia}_Liquidacion_Numero_${id}.xlsx`;
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                toast.error("Error al generar el archivo.");
            }
        } catch (err) {
            err.response?.data?.errores
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo descargarse el archivo");
        } finally {
            this.setState({
                showSpinner: false
            });
        }
    }

    async exportarRetencionesYPercepciones(id, razonSocial) {
        let request = {
            idLiquidacion: id,
        };

        try {
            let res = await fetchExportarRetencionesYPercepcionesApi(request)

            let base64Zip = res.data.comprimidoZip;

            if (base64Zip) {
                let razonSocialSeller = razonSocial.replace(/[^a-zA-Z0-9]/g, "_");
                let fileName = `retencionesYPercepciones_${razonSocialSeller}.zip`;

                this.descargarZip(base64Zip, fileName);
            } else {
                toast.error("No se pudo generar el archivo .zip.");
            }
        } catch (err) {
            err.response?.data?.errores
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo descargarse el archivo .zip");
        }
    }

    descargarZip(base64, fileName) {
        // Convertir Base64 a Blob
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/zip" });

        // Crear URL y descargar
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    selectSearchHandler = (options, config) => {
        this.setState({ [config.name]: options });
    }

    handleOpenTipoFactura = () => {

        getTipoComprobantesApi().then(response => {

            const opciones = response.data.tipoComprobantes?.map(item => ({
                value: item.idTipoComprobante,
                label: item.descripcion
            })) || [];

            this.setState({ opcionesTipoFactura: opciones });
        });
    };

    async calcularPercepcionRetencion(idLiquidacion) {


        this.setState({
            showSpinner: true
        });

        let request = {
            idLiquidacion: idLiquidacion,
        };



        try {
            const res = await this.props.fetchCalcularPercepcionRetencion(request);
            const { totalRetenciones, totalPercepcion, retenciones } = this.props.percepcionRetencionLiquidacion;

            // Valores anteriores
            const oldTotalPercepcion = this.props.liquidacion_por_id.totalPercepcion || 0;
            const oldTotalFacturar = this.props.liquidacion_por_id.totalFacturar || 0;

            // Calculo de diferencias (Deltas)
            const deltaPercepcion = totalPercepcion - oldTotalPercepcion;

            // Actualizamos solo Total Facturar sumarizando la diferencia de percepciones
            const newTotalFacturar = oldTotalFacturar + deltaPercepcion;

            const liquidacionEstadoActualizado = {
                ...this.props.liquidacion_por_id,
                totalRetenciones: totalRetenciones,
                totalPercepcion: totalPercepcion,
                totalFacturar: newTotalFacturar
            };

            this.props.updateEstadoLiquidacion(liquidacionEstadoActualizado);

            this.props.actualizarTotalRetencionesOrdenes(retenciones, this.props.cuerpoOrdenLiquidaciones);

        } catch (err) {
            err.response?.data?.errores
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo calcularse");
        } finally {
            this.setState({ showSpinner: false });
        }

    };



    verDetalleRetencionesPercepciones = (id, origen = "orden") => {

        const { detalleTributarioOrdenes, detalleTributarioLiquidacion } = this.props;
        const idLiquidacion = this.props.liquidacion_por_id.idLiquidacion;

        const yaTienePercepciones = origen === "liquidacion" && detalleTributarioLiquidacion?.length > 0;
        const yaTieneRetenciones = origen === "orden" && detalleTributarioOrdenes?.some(o => o.id === id);

        if ((origen === "liquidacion" && yaTienePercepciones) || (origen === "orden" && yaTieneRetenciones)) {
            this.setState({
                mostrarModalPercepciones: origen === "liquidacion",
                mostrarModalRetenciones: origen === "orden",
                ordenIdSeleccionado: origen === "orden" ? id : null
            });
            return;
        }

        // Solo entra acá si no tiene datos aún
        this.props.fetchDetalleRetenciones(idLiquidacion, origen, id);

        this.setState({
            mostrarModalPercepciones: origen === "liquidacion",
            mostrarModalRetenciones: origen === "orden",
            ordenIdSeleccionado: origen === "orden" ? id : null
        });
    };




    cerrarModalRetenciones = () => {
        this.setState({ mostrarModalRetenciones: false });
    };


    handleVerDetallePercepciones = () => {
        this.setState({ mostrarModalPercepciones: true });
    };

    handleCerrarModalPercepciones = () => {
        this.setState({ mostrarModalPercepciones: false });
    };

    async exportarCertificadosPdf(id) {
        this.setState({ showSpinnerCertificados: true });

        let request = {
            idLiquidacion: id
        };

        try {
            let res = await fetchExportarCertificadosPdfApi(request);
            let base64Zip = res.data.comprimidoZip;

            if (base64Zip) {
                this.descargarZip(base64Zip, "certificadosPdf.zip");
            } else {
                toast.error("No se pudo generar el archivo ZIP.");
            }
        } catch (err) {
            err.response?.data?.errores
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo descargarse el archivo .zip");
        } finally {
            this.setState({ showSpinnerCertificados: false });
        }
    }

    render() {
        const contaduria = 8;
        let isCategory = 1;
        let isAdminMod = 2;
        let isSellerAdmin = 3;
        let isSeller = 4;

        const { tipoUsuario, liquidacion_por_id } = this.props;
        const { ordenIdSeleccionado } = this.state;

        const detalleFiltrado = Array.isArray(this.props.detalleTributarioOrdenes)
            ? this.props.detalleTributarioOrdenes.filter(o => o.id === ordenIdSeleccionado)
            : [];

        const isConfirmada = liquidacion_por_id?.idTipoEstadoLiquidacion === 3;

        // Determina si hay valores de retenciones o percepciones
        const tieneValoresCalculados = (liquidacion_por_id?.totalRetenciones > 0 || liquidacion_por_id?.totalPercepcion > 0);

        // Si es Contaduria o Category, verificamos si está calculado para habilitar campos/botones
        // Si no tiene valores calculados, se bloquea el resto y solo deja Calcular
        const esUsuarioRestringido = (tipoUsuario === contaduria || tipoUsuario === isCategory);

        // Bloqueo general si está cargando
        const bloqueoPorCarga = this.state.showSpinner || this.state.spinnerConfirmar;
        const accionesDescargaHabilitadas = isConfirmada || tieneValoresCalculados;
        const mensajeBloqueo = "No se encuentra calculada la percepcion y retencion";

        return (
            <div className="container" style={{ pointerEvents: bloqueoPorCarga ? 'none' : 'auto', opacity: bloqueoPorCarga ? 0.6 : 1 }}>

                {bloqueoPorCarga && (
                    <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 9999 }}>
                        <MiniSpinner />
                    </div>
                )}

                <div>
                    <input type="hidden" id="valores_ordenes_editar"></input>
                    <input type="hidden" id="valores_novedades_editar"></input>
                </div>

                <DetalleLiquidacionEditar
                    liquidacion={this.props.liquidacion_por_id}
                    isBorrador={true}
                    VerDetallePercepciones={this.handleVerDetallePercepciones}
                    onVerDetallePercepciones={this.verDetalleRetencionesPercepciones}
                >
                    {(tipoUsuario === contaduria || tipoUsuario === isCategory) && (
                        <div className="card mt-3 border-0 shadow-sm">
                            <div className="card-body p-3">
                                <h6 className="card-subtitle mb-3 text-muted text-uppercase fw-bold" style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>
                                    Datos de Facturación
                                </h6>
                                <div className="row g-3">
                                    <div className="col-12">
                                        <label className="form-label text-secondary fw-medium mb-1" style={{ fontSize: '0.85rem' }}>NUMERO DE FACTURA</label>
                                        <div className="input-group input-group-sm">
                                            <span className="input-group-text bg-light border-end-0">
                                                <i className="fa fa-hashtag text-muted"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control border-start-0 ps-0"
                                                value={this.state.numeroFactura ?? this.props.liquidacion_por_id?.numeroComprobante ?? ""}
                                                onChange={this.handleNumeroFacturaChange}
                                                placeholder="Ej: 0001-00001234-A"
                                                disabled={isConfirmada || !tieneValoresCalculados}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <label className="form-label text-secondary fw-medium mb-1" style={{ fontSize: '0.85rem' }}>TIPO DE FACTURA</label>
                                        <Select
                                            name="tipoFactura"
                                            value={
                                                this.state.tipoFactura && this.state.tipoFactura.value
                                                    ? this.state.tipoFactura
                                                    : {
                                                        value: this.props.liquidacion_por_id?.idTipoFactura ?? '',
                                                        label: this.props.liquidacion_por_id?.descripcionTipoFactura ?? 'Seleccionar...'
                                                    }
                                            }

                                            options={this.state.opcionesTipoFactura}
                                            onChange={this.selectSearchHandler}
                                            components={{ DropdownIndicator: () => DropDownArrow }}
                                            styles={customStyle}
                                            onMenuOpen={this.handleOpenTipoFactura}
                                            isDisabled={isConfirmada || !tieneValoresCalculados}
                                            placeholder="Seleccionar..."
                                        />
                                    </div>

                                    <div className="col-12">
                                        <label className="form-label text-secondary fw-medium mb-1" style={{ fontSize: '0.85rem' }}>CODIGO SAP</label>
                                        <div className="input-group input-group-sm">
                                            <span className="input-group-text bg-light border-end-0">
                                                <i className="fa fa-barcode text-muted"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control border-start-0 ps-0"
                                                value={this.state.codigoSAP ?? this.props.liquidacion_por_id?.codigoSap ?? ""}
                                                onChange={(e) => this.setState({ codigoSAP: e.target.value })}
                                                placeholder="Ingrese Código SAP"
                                                disabled={isConfirmada || !tieneValoresCalculados}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </DetalleLiquidacionEditar>


                <div className="d-flex justify-content-between align-items-center my-4">

                    {/* Grupo Izquierdo: Volver + Exportaciones (Solo Iconos) */}
                    <div className="d-flex gap-2 align-items-center">
                        <div onClick={this.props.resetPercepcionRetencionLiquidacion} style={{ cursor: 'pointer' }} title="Volver">
                            <GoBackArrow />
                        </div>

                        {(tipoUsuario === isCategory || tipoUsuario === isAdminMod || tipoUsuario === contaduria) && (
                            <>
                                {/* Boton Certificados PDF */}
                                <button
                                    type="button"
                                    title="Descargar Certificados PDF"
                                    className={`btn btn-sm shadow fw-medium d-flex align-items-center justify-content-center ${accionesDescargaHabilitadas ? 'btn-danger' : 'btn-secondary'}`}
                                    style={{ width: '32px', height: '32px', padding: 0 }}
                                    onClick={() => this.exportarCertificadosPdf(this.props.liquidacion_por_id.idLiquidacion)}
                                    disabled={!accionesDescargaHabilitadas || this.state.showSpinnerCertificados}
                                >
                                    {this.state.showSpinnerCertificados ? <MiniSpinner size={14} /> : <FileText size={18} />}
                                </button>


                                {/* Boton Retenciones y Percepciones */}
                                <button
                                    title="Descargar Retenciones y Percepciones"
                                    disabled={!accionesDescargaHabilitadas || this.state.showSpinner}
                                    onClick={() => this.exportarRetencionesYPercepciones(
                                        this.props.liquidacion_por_id.idLiquidacion,
                                        this.props.liquidacion_por_id.razonSocialSeller
                                    )}
                                    className={`btn btn-sm shadow fw-medium d-flex align-items-center justify-content-center ${accionesDescargaHabilitadas ? 'btn-danger' : 'btn-secondary'}`}
                                    style={{ width: '32px', height: '32px', padding: 0 }}
                                >
                                    <Download size={18} />
                                </button>

                                {/* Boton Exportar Excel */}
                                <button
                                    title="Exportar a Excel"
                                    className={`btn btn-sm shadow fw-medium d-flex align-items-center justify-content-center btn-danger`}
                                    style={{ width: '32px', height: '32px', padding: 0 }}
                                    onClick={() =>
                                        this.descargarExcelBorradorLiquidaciones(
                                            this.props.liquidacion_por_id.idLiquidacion,
                                            this.props.liquidacion_por_id.razonSocialSeller
                                        )
                                    }
                                    disabled={this.state.showSpinner}
                                >
                                    {this.state.showSpinner ? <MiniSpinner size={14} /> : <FileSpreadsheet size={18} />}
                                </button>
                            </>
                        )}
                    </div>

                    {/* Grupo Derecho: Acciones de Liquidación (Texto) */}
                    <div className="d-flex gap-2 align-items-center">
                        {!isConfirmada && (
                            <>
                                {(tipoUsuario === contaduria || tipoUsuario === isSeller || tipoUsuario === isCategory) && (
                                    this.state.showSpinner ? <MiniSpinner /> :
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-danger shadow fw-medium"
                                            onClick={() => this.calcularPercepcionRetencion(this.props.liquidacion_por_id.idLiquidacion)}
                                        >
                                            Calcular Percepción y Retención
                                        </button>
                                )}

                                {!(tipoUsuario === contaduria) && (
                                    <button
                                        title="Eliminar Liquidacion"
                                        type="button"
                                        className="btn btn-sm btn-secondary shadow fw-medium"
                                        onClick={() => this.eliminarLiquidacion(this.state.request.idLiquidacion)}
                                    >
                                        Anulacion Liquidacion
                                    </button>
                                )}

                                {(tipoUsuario === 1 || tipoUsuario === 2) && (
                                    <form className="form-horizontal form-material m-0" onSubmit={this.editarBorrador}>
                                        <button id="botonBorrador" type="submit" className="btn btn-sm btn-secondary shadow fw-medium">
                                            Guardar Borrador
                                        </button>
                                    </form>
                                )}
                            </>
                        )}

                        {/* Boton Confirmar Liquidacion - Visible siempre para Contaduria, o si no está confirmada para Category */}
                        {((tipoUsuario === contaduria) || (!isConfirmada && tipoUsuario === isCategory)) && (
                            this.state.spinnerConfirmar ? (
                                <MiniSpinner />
                            ) : (
                                <form className="form-horizontal form-material m-0" onSubmit={(e) => {
                                    e.preventDefault();
                                    this.confirmarLiquidacion(e);
                                }}>
                                    <button
                                        disabled={this.state.showSpinner || !tieneValoresCalculados}
                                        id="botonLiquidada"
                                        type="submit"
                                        className={`btn btn-sm shadow fw-medium ${!tieneValoresCalculados ? 'btn-secondary' : 'btn-danger'}`}
                                    >
                                        Confirmar Liquidacion
                                    </button>
                                </form>
                            )
                        )}
                    </div>

                </div>






                <OrdenesDeLiquidacionBorrador
                    isLoading={this.props.isLoadingDetalleLiquidacion}
                    ordenes={this.props.cuerpoOrdenLiquidaciones}
                    ref={this.idOrdenesSeleccionadas}
                    liquidacion={this.props.liquidacion_por_id}
                    onVerDetalleRetenciones={this.verDetalleRetencionesPercepciones}
                //esContaduria={tipoUsuario === 8}
                />

                <NovedadesDeLiquidacionBorrador
                    isLoading={this.props.isLoadingDetalleLiquidacion}
                    novedades={this.props.cuerpoNovedadLiquidaciones}
                    ref={this.idNovedadesSeleccionadas}
                />

                <LogisticaDeLiquidacion
                    isLoading={this.props.isLoadingDetalleLiquidacion}
                    logistica={this.props.cuerpoFeeLogisticoLiquidaciones}
                />

                <RebatesDeLiquidacion
                    detalleRebate={this.props.detalleRebate}
                    isLoading={this.props.isLoadingDetalleLiquidacion}
                />

                <ModalDetallePercepciones
                    isLoading={this.props.isLoadingDetalleLiquidacion}
                    show={this.state.mostrarModalPercepciones}
                    onHide={this.handleCerrarModalPercepciones}
                    percepciones={this.props.detalleTributarioLiquidacion}
                />

                <ModalDetalleRetenciones
                    show={this.state.mostrarModalRetenciones && !this.props.isLoadingDetalleLiquidacion}
                    onHide={this.cerrarModalRetenciones}
                    detalle={detalleFiltrado}
                    isLoading={this.props.isLoadingDetalleRetenciones}
                />

                <Modal
                    show={this.state.mostrarModalDecisionFactura}
                    onHide={() => this.setState({ mostrarModalDecisionFactura: false })}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmar Facturación</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>¿Desea facturar la liquidación de manera manual o automática?</p>
                        <ul className="text-muted small">
                            <li><strong>Manual:</strong> Continúa con la confirmación de la liquidación sin impactar facturas externas.</li>
                            <li><strong>Automática:</strong> Confirma la liquidación y emite la factura automáticamente.</li>
                        </ul>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ mostrarModalDecisionFactura: false })}>
                            Cancelar
                        </Button>
                        <Button variant="outline-primary" onClick={this.ejecutarConfirmacionManual}>
                            Factura Manual
                        </Button>
                        <Button variant="primary" onClick={this.ejecutarFacturacionAutomatica}>
                            Facturación Automática
                        </Button>
                    </Modal.Footer>
                </Modal>

            </div >
        );
    }
}


const mapStateToProps = state => ({
    isLoadingDetalleLiquidacion: state.liquidaciones.isLoadingDetalleLiquidacion,
    liquidacion_por_id: state.liquidaciones.liquidacion_por_id,
    liquidacion_por_id_ordenes: state.liquidaciones.liquidacion_por_id_ordenes,
    liquidacion_por_id_novedades: state.liquidaciones.liquidacion_por_id_novedades,
    liquidacion_por_id_logistica: state.liquidaciones.liquidacion_por_id_logistica,
    lista_resultados_liquidaciones: state.liquidaciones.lista_resultados_liquidaciones,
    liquidaciones: state.liquidaciones.lista_liquidaciones_busqueda,
    tipoUsuario: state.general.tipoUsuario,
    cuerpoOrdenLiquidaciones: state.liquidaciones.cuerpoOrdenLiquidaciones || [],
    cuerpoFeeLogisticoLiquidaciones: state.liquidaciones.cuerpoFeeLogisticoLiquidaciones || [],
    cuerpoNovedadLiquidaciones: state.liquidaciones.cuerpoNovedadLiquidaciones || [],
    detalleRebate: state.liquidaciones.detalleRebate || [],
    detalleTributarioOrdenes: state.liquidaciones.detalleTributarioOrdenes || [],
    detalleTributarioLiquidacion: state.liquidaciones.detalleTributarioLiquidacion || [],
    percepcionRetencionLiquidacion: state.liquidaciones.percepcionRetencionLiquidacion || {},
    isLoadingDetalleRetenciones: state.liquidaciones.isLoadingDetalleRetenciones,
});

export default connect(mapStateToProps, {
    fetchLiquidacionporid,
    fetchLiquidacionporidOrdenes,
    fetchLiquidacionporidNovedades,
    fetchLiquidacionporidLogistica,
    resetLiquidaciones,
    fetchResultadosLiquidaciones,
    updateLiquidaciones,
    putConfirmarLiquidacion,
    updateEstadoLiquidacion,
    limpiarLiquidacionesBusqueda,
    updateEstadoListLiquidacion,
    fetchDetalleRetenciones,
    resetPercepcionRetencionLiquidacion,
    fetchCalcularPercepcionRetencion,
    actualizarTotalRetencionesOrdenes
})(EditarLiquidacionBorradorWrapper);